import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import logo from '../../assets/logo.png';

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'About Us', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Clients', path: '/clients' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Certificates', path: '/certificate' },
    { name: 'Contact Us', path: '/contact' },
  ];

  const isActive = (path) => {
    if (path === '#') return false;
    return location.pathname === path;
  };

  const handleClick = (e, path) => {
    if (path === '#') {
      e.preventDefault();
      alert('Certificates section coming soon!');
    }
  };

  return (
    <header 
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg py-2' : 'bg-white py-4'
      }`}
    >
      <nav className="container mx-auto px-4">
        <div className="flex justify-between items-center">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img src={logo} alt="Shiv Shakti" className="h-12 w-auto" />
            <div>
              <span className="text-xl font-bold text-[#2F3C7E] block">Shiv Shakti</span>
              <span className="text-xs text-[#E6B325] tracking-wider">HOSPITALITY</span>
            </div>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-1">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={(e) => handleClick(e, item.path)}
                className={`px-4 py-2 rounded-md text-sm font-medium transition-colors
                  ${isActive(item.path) 
                    ? 'bg-[#E6B325] text-[#2F3C7E]' 
                    : item.path === '#'
                      ? 'text-gray-400 cursor-pointer hover:bg-gray-100 hover:text-gray-600'
                      : 'text-gray-700 hover:bg-gray-100 hover:text-[#E6B325]'
                  }`}
              >
                <span className="flex items-center">
                  {item.name}
                  {item.path === '#' && (
                    <span className="ml-2 text-xs bg-gray-200 text-gray-600 px-1.5 py-0.5 rounded">Soon</span>
                  )}
                </span>
              </Link>
            ))}
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-[#2F3C7E]"
            onClick={() => setIsOpen(!isOpen)}
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && (
          <div className="md:hidden mt-4 pb-4 bg-white">
            {navItems.map((item) => (
              <Link
                key={item.name}
                to={item.path}
                onClick={(e) => {
                  handleClick(e, item.path);
                  setIsOpen(false);
                }}
                className={`block py-3 px-4 rounded-md mb-1 transition-colors
                  ${isActive(item.path)
                    ? 'bg-[#E6B325] text-[#2F3C7E] font-medium'
                    : item.path === '#'
                      ? 'text-gray-400 hover:bg-gray-100'
                      : 'text-gray-700 hover:bg-gray-100 hover:text-[#E6B325]'
                  }`}
              >
                <span className="flex items-center justify-between">
                  {item.name}
                  {item.path === '#' && (
                    <span className="text-xs bg-gray-200 text-gray-600 px-2 py-0.5 rounded">Coming Soon</span>
                  )}
                </span>
              </Link>
            ))}
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;